import { doc, getDoc } from 'firebase/firestore';
import { db } from '../../../firebase';

// pricing/base is a simple key:value object like { "1": 14.99, "2": 15.99 }
export async function listPricingLevels() {
  const snap = await getDoc(doc(db, 'pricing', 'base'));
  const data = snap.data() || {};

  return Object.entries(data)
    .map(([level, price]) => ({
      level: Number(level),
      price: Number(price)
    }))
    .sort((a, b) => a.level - b.level);
}
